/**
 * Masks Aadhaar number - shows only last 4 digits
 * Format: XXXXXX1234
 * @param {string} aadhaar - Aadhaar number (12 digits)
 * @returns {string} Masked Aadhaar number
 */
export const maskAadhaar = (aadhaar) => {
  if (!aadhaar || aadhaar === '' || aadhaar === 'N/A') {
    return aadhaar || 'N/A';
  }
  
  const aadhaarStr = String(aadhaar).trim();
  if (aadhaarStr.length < 4) {
    return aadhaarStr;
  }
  
  // Show last 4 digits, mask the rest
  const lastFour = aadhaarStr.slice(-4);
  const maskedPart = 'X'.repeat(Math.max(0, aadhaarStr.length - 4));
  return maskedPart + lastFour;
};

/**
 * Masks PAN card number - shows first 5 characters and last 1 character
 * Format: ABCDE****F
 * @param {string} pan - PAN card number
 * @returns {string} Masked PAN card number
 */
export const maskPAN = (pan) => {
  if (!pan || pan === '' || pan === 'N/A') {
    return pan || 'N/A';
  }
  
  const panStr = String(pan).trim().toUpperCase();
  if (panStr.length < 6) {
    return panStr;
  }
  
  // PAN format: ABCDE1234F (10 characters)
  // Show first 5 and last 1, mask middle 4
  if (panStr.length === 10) {
    return panStr.substring(0, 5) + '****' + panStr.substring(9);
  }
  
  // For non-standard PAN lengths, show first 3 and last 1
  if (panStr.length > 4) {
    const firstPart = panStr.substring(0, Math.min(3, panStr.length - 1));
    const lastChar = panStr.substring(panStr.length - 1);
    const maskedLength = panStr.length - firstPart.length - 1;
    return firstPart + '*'.repeat(Math.max(0, maskedLength)) + lastChar;
  }
  
  return panStr;
};

